<template>
    <div class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <transition name="fade" appear>
                <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>
            </transition>

            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <transition name="pop" appear>
                <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div v-if="!processing" class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div class="sm:flex sm:items-start">
                            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-red-100 sm:mx-0">
                                <font-awesome-icon class="text-xl text-red-600" icon="exclamation-triangle"/>
                            </div>
                            <div v-if="balance > 0" class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <h3 class="text-lg leading-6 font-medium text-gray-900">
                                    {{$t('Withdrawal')}} {{balance | currency}}
                                </h3>
                                <div class="mt-1">
                                    <p class="text-sm text-gray-500">
                                        {{$t('Are you sure you want to withdraw all funds?')}}
                                    </p>
                                </div>
                            </div>

                            <div v-if="balance <= 0" class="mt-2 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <h3 class="text-lg leading-6 font-medium text-gray-900">
                                    {{$t('Withdrawal error')}}
                                </h3>
                                <div class="mt-1">
                                    <p class="text-sm text-gray-500">
                                        {{$t('Insufficient funds')}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="processing" class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div class="text-lg text-center">
                            <font-awesome-icon icon="spinner" class="mr-2" pulse /> <span>{{$t('Please wait')}}</span>
                        </div>
                    </div>
                    <div class="bg-gray-50 p-2 sm:flex sm:flex-row-reverse">
                        <button v-if="balance > 0" :disabled="processing" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" @click="confirmWithdrawal">
                            {{$t('Confirm')}}
                        </button>
                        <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" @click="cancelWithdrawal">
                            {{$t('Cancel')}}
                        </button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: "Withdrawal",
    data() {
        return {
            balance: null,
            processing: false,
        };
    },
    methods: {
        cancelWithdrawal() {
            this.$emit('close');
        },
        async confirmWithdrawal() {
            if(this.balance > 0) {
                if (!this.processing) {
                    this.processing =true;
                    await this.$inertia.post(this.route('terminal.withdraw'));
                }
            }
            this.$emit('close');
            this.processing = false;
        },
        keyListener(e) {
            switch (e.key) {
                case 'c':
                    e.preventDefault();
                    this.confirmWithdrawal();
                    break;
                case 'h':
                    e.preventDefault();
                    this.cancelWithdrawal();
                    break;
                default:
                    e.preventDefault();
                    break;
            }
        },
    },
    async created() {
        window.addEventListener('keydown', this.keyListener);
        document.querySelector("body").classList.remove("overflow-hidden");
        this.processing = true;
        const response = await axios.get(this.route('terminal.balance'));
        if (response) {
            this.balance = response.data.balance;
        }
        this.processing = false;
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.keyListener);
        document.querySelector("body").classList.add("overflow-hidden");
    },
};
</script>


<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s linear;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
    transition: transform 0.3s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.3s linear;
}

.pop-enter,
.pop-leave-to {
    opacity: 0;
    transform: scale(0.2) translateY(-30%);
}
</style>
